"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _constants = require("./constants");

function getTrackHandler(Tracker) {
  return function (_ref) {
    var eventKey = _ref.eventKey,
        eventProperties = _ref.eventProperties;
    Tracker.track(eventKey, eventProperties);
  };
}

var _default = function _default(Tracker) {
  var handlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var track = getTrackHandler(Tracker);
  return function (store) {
    return function (next) {
      return function (action) {
        var prevState = store.getState();
        var result = next(action);
        var explicitEventSpec = action.meta && action.meta[_constants.TRACK_EVENT];
        var handler = handlers[action.type];

        if (explicitEventSpec) {
          track(explicitEventSpec);
        } else if (typeof handler === 'function') {
          handler(action, store.getState(), store.dispatch, prevState);
        } else if ((0, _typeof2.default)(handler) === 'object') {
          track(handler);
        }

        return result;
      };
    };
  };
};

exports.default = _default;
module.exports = exports.default;